import { DEFAULT_CURRENCY } from "@/data/constants";
import { toCurrencyCode } from "./toCurrencyCode";

type FormatCurrencyOptions = Intl.NumberFormatOptions & {
  locale?: string;
};

/** Formats a major-unit amount as a localized currency string. */
function formatCurrency(
  number: number,
  currency: string = DEFAULT_CURRENCY,
  options: FormatCurrencyOptions = {},
) {
  if (!Number.isFinite(number)) {
    return "Invalid input";
  }

  const currencyCode = toCurrencyCode(currency) ?? DEFAULT_CURRENCY;
  const { locale = "en-US", ...formatOptions } = options;

  try {
    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...formatOptions,
    });

    return formatter.format(number);
  } catch {
    return `${currency}${number.toFixed(2)}`;
  }
}

export default formatCurrency;
